import type { InsertedContentIdentity } from '@atlassian/malleable-ui-components/types';
import type { CwrCreateEntryPoint } from '@atlassian/rovo-content-bridge-api-commands/commands/confluence-create-page-command';
import type { CwrRemixInvokedFrom } from '@atlassian/rovo-content-bridge-api-commands/commands/confluence-update-page-command';

export type CwrRemixEditorAccess = {
	getEditorRoot: () => HTMLElement;
	getResultElement: (identity: InsertedContentIdentity) => HTMLElement | undefined;
};

export type CwrRemixResult = {
	createdContentMetadata: Record<string, unknown>;
	createdContentType: string;
	dynamicUiSubtype?: string;
	identity: InsertedContentIdentity;
	previousLocalId?: string;
	previousResultId?: string;
	userAction: 'edit' | 'insert';
};

export const getCwrRemixResultInstrumentationId = (
	parentInstrumentationId: string | undefined,
	resultIndex: number,
): string | undefined =>
	parentInstrumentationId ? `${parentInstrumentationId}:${resultIndex}` : undefined;

/** Semantic metadata emitted before the matching CWR ADF update is applied. */
export type CwrRemixVisualMetadata = {
	dynamicUiSubtype?: string;
	dynamicUiType: string;
};

export type CwrRemixReplacement = {
	previousLocalId: string;
	previousResultId: string;
};

export type OnCwrRemixResultAppliedCallback = (
	params: (
		| {
				actionKey: 'aifc-adf-update' | 'dynamic-ui-create';
				invokedFrom: CwrRemixInvokedFrom;
		  }
		| {
				actionKey: 'aifc-confluence-page-create';
				invokedFrom?: CwrCreateEntryPoint;
		  }
	) & { result: CwrRemixResult; singleInstrumentationId?: string },
) => void;

export type OnCwrRemixReplacementCallback = (replacement: CwrRemixReplacement) => void;
